import { gate as v3gate } from 'hub-http/gates';
export const CONVERSATION_SUMMARY_GATE = 'Communication:AI:ConversationSummary';
export const LIMITED_TICKET_FUNCTION = 'HelpDesk:LimitedTicketFunctionInInbox';
export const CONVERSATION_TICKET_STATUS_CONDITIONAL_PROPERTIES = 'Conversations:TicketStatusConditionalProperties';
export const HELP_DESK_ROUTING_SCOPE_FILTERING = 'HelpDeskRoutingScopeFiltering';
export const ROUTING_REASSIGNMENT_CHIRP = 'Routing:ReassignmentCHIRP';
export const ROUTING_DISTRIBUTION = v3gate('Routing:Distribution');